/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Updated_AtInputs */

const fr_legal_updated_at = /** @type {(inputs: Legal_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour : Mars 2026`)
};

const en_legal_updated_at = /** @type {(inputs: Legal_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: March 2026`)
};

/**
* | output |
* | --- |
* | "Last updated: March 2026" |
*
* @param {Legal_Updated_AtInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_updated_at = /** @type {((inputs?: Legal_Updated_AtInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Updated_AtInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_updated_at(inputs)
	return en_legal_updated_at(inputs)
});